<!-- Step 2 body — Fulfillment details (handoff §Step 2 / 3b). Branches on the
     step-1 choice: pickup/proxy = calendar + slots (+ proxy contact card);
     shipping = address rows + instructions. -->

<vb-banner *ngIf="hasPickupScheduled" tone="info" class="ful-banner">
    <strong>Pickup already scheduled.</strong> Your pickup has already been
    arranged — payment is the only remaining step.
</vb-banner>

<ng-container *ngIf="!hasPickupScheduled">
    <!-- ============ PICKUP / PROXY PICKUP ============ -->
    <ng-container *ngIf="selectedDeliveryMethod !== 'shipping'">
        <div class="ful-proxy" *ngIf="selectedDeliveryMethod === 'proxyPickup'">
            <p class="ful-proxy__help">
                We'll text this person when the order is ready to collect.
            </p>
            <label class="ful-field">
                <span class="ful-field__label">Full name</span>
                <input
                    name="proxyName"
                    type="text"
                    placeholder="First and last name"
                    [(ngModel)]="proxyName"
                    #nameModel="ngModel"
                    vbPersonName
                    required />
                <span
                    class="ful-field__error"
                    *ngIf="
                        nameModel.invalid &&
                        (nameModel.dirty || nameModel.touched)
                    ">
                    Name is required
                </span>
            </label>
            <label class="ful-field">
                <span class="ful-field__label">Phone number</span>
                <input
                    name="proxyTelephone"
                    type="tel"
                    placeholder="(416) 555-0123"
                    maxlength="14"
                    pattern="^(\(\d{3}\)|\d{3})-?\d{3}-?\d{4}$"
                    [(ngModel)]="proxyTelephone"
                    #proxyTelephoneModel="ngModel"
                    (keypress)="allowPhoneInput($event)"
                    required />
                <span
                    class="ful-field__error"
                    *ngIf="
                        proxyTelephoneModel.invalid &&
                        (proxyTelephoneModel.dirty ||
                            proxyTelephoneModel.touched)
                    ">
                    <ng-container
                        *ngIf="proxyTelephoneModel.errors?.['required']">
                        Phone number is required
                    </ng-container>
                    <ng-container
                        *ngIf="proxyTelephone && !proxyTelephoneModel.valid">
                        Phone number is invalid
                    </ng-container>
                </span>
            </label>
        </div>

        <span class="ful-eyebrow">Select pickup date &amp; time</span>
        <div class="ful-grid">
            <vb-pickup-calendar
                (dateSelected)="handleDateSelect($event)">
            </vb-pickup-calendar>
            <vb-pickup-time-slots
                [morningSlots]="morningSlots"
                [afternoonSlots]="afternoonSlots"
                (pickupSlotSelectedEvent)="handleTimeSlotSelect($event)">
            </vb-pickup-time-slots>
        </div>

        <div
            class="ful-booking"
            *ngIf="
                selectedSlot &&
                (selectedDeliveryMethod !== 'proxyPickup' ||
                    (proxyName && proxyTelephone && isProxyPhoneValid()))
            ">
            <span class="ful-booking__text">
                Booking for
                <strong>{{ selectedDate | vbDate }}</strong>
                at
                <strong>{{ selectedSlot.slotLabel }} {{ selectedSlot.zone }}</strong>
            </span>
            <vb-button variant="primary" (clicked)="onFulfillmentNextClick()">
                Confirm pickup
            </vb-button>
        </div>
    </ng-container>

    <!-- ============ SHIPPING ============ -->
    <ng-container *ngIf="selectedDeliveryMethod === 'shipping'">
        <p class="ful-intro">
            Shipping is quoted from the size, weight and destination of your
            lots — allow <strong>1–2 business days</strong> for the quote.
            Confirm the address below so it's accurate.
        </p>

        <span class="ful-eyebrow">Ship to</span>
        <div class="ful-addresses" role="radiogroup" aria-label="Ship to">
            <vb-option-row
                *ngFor="let address of userAddresses"
                [label]="addressLine1(address)"
                [description]="addressLine2(address)"
                [selected]="isAddressSelected(address)"
                [tag]="isDefaultAddress(address.id) ? 'Default' : null"
                (clicked)="selectAddress(address)">
            </vb-option-row>
        </div>
        <button type="button" class="ful-addlink" (click)="goToAddAddress()">
            + Add new address
        </button>

        <label class="ful-field ful-field--instructions">
            <span class="ful-field__label">Additional instructions</span>
            <textarea
                rows="3"
                maxlength="200"
                placeholder="Buzzer code, delivery notes…"
                [(ngModel)]="instructions"></textarea>
        </label>

        <div class="ful-actions">
            <vb-button
                variant="primary"
                [disabled]="selectedShippingAddress === null"
                (clicked)="onFulfillmentNextClick()">
                Next
            </vb-button>
        </div>
    </ng-container>
</ng-container>
